export default "__VITE_ASSET__mLJSR4yz__"